module.exports = __webpack_public_path__ + "img/pumpTruck4.6612150a.png";